module.exports = __webpack_public_path__ + "img/sleeve cuff length.8cf4e22a.png";